{
  "required": "Required",
  "email": {
    "invalid": "Invalid email address",
    "company": "Please use a company email address"
  },
  "phone": {
    "invalid": "Invalid phone number"
  },
  "text": {
    "tooShort_one": "Must be at least {{count}} character",
    "tooShort_other": "Must be at least {{count}} characters",
    "tooLong_one": "Must be at most {{count}} character",
    "tooLong_other": "Must be at most {{count}} characters"
  }
}
